(function () {
  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.prototype.slice.call((root || document).querySelectorAll(sel));

  function hasAccessoriesUI() {
    return !!$("[data-pm-accessories]");
  }

  function collectAccessories() {
    const wrap = $("[data-pm-accessories]");
    if (!wrap) return [];

    const cards = $$("[data-pm-acc-card]", wrap);
    const items = [];

    cards.forEach(card => {
      const toggle = $("[data-pm-acc-toggle]", card);
      if (!toggle || !toggle.checked) return;

      const select = $("[data-pm-acc-variant]", card);
      const qtyInput = $("[data-pm-acc-qty]", card);
      if (!select) return;

      const opt = select.selectedOptions && select.selectedOptions[0];
      if (opt && opt.disabled) return;

      let qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!Number.isFinite(qty) || qty < 1) qty = 1;

      const id = Number(select.value);
      if (!id) return;

      items.push({ id, quantity: qty });
    });

    return items;
  }

  function bindToggles() {
    const wrap = $("[data-pm-accessories]");
    if (!wrap) return;

    wrap.addEventListener("change", (e) => {
      const toggle = e.target.closest("[data-pm-acc-toggle]");
      if (!toggle) return;

      const card = toggle.closest("[data-pm-acc-card]");
      if (!card) return;

      const body = $("[data-pm-acc-body]", card);
      if (!body) return;

      body.hidden = !toggle.checked;

      if (toggle.checked) {
        const qty = $("[data-pm-acc-qty]", card);
        if (qty) {
          const v = parseInt(qty.value, 10);
          if (!Number.isFinite(v) || v < 1) qty.value = "1";
        }
      }
    });

    wrap.addEventListener("input", (e) => {
      const qty = e.target.closest("[data-pm-acc-qty]");
      if (!qty) return;
      const v = parseInt(qty.value, 10);
      if (!Number.isFinite(v) || v < 1) qty.value = "1";
    });
  }

  // --- Fetch intercept (theme-independent) ---
  const originalFetch = window.fetch.bind(window);
  let pmInjectGuard = false;
  let pmReloadGuard = false;

  function isCartAddRequest(url) {
    try {
      const u = typeof url === "string" ? url : (url && url.url ? url.url : "");
      return u.includes("/cart/add");
    } catch (e) {
      return false;
    }
  }

  async function parseBodyToObject(init) {
    if (!init || !init.body) return null;

    if (typeof init.body === "string") {
      const txt = init.body.trim();
      if (!txt) return null;

      if (txt[0] === "{" || txt[0] === "[") {
        try { return JSON.parse(txt); } catch (e) {}
      }

      try {
        const params = new URLSearchParams(txt);
        const obj = {};
        params.forEach((v, k) => (obj[k] = v));
        return obj;
      } catch (e) {}
    }

    if (init.body instanceof FormData) {
      const obj = {};
      for (const [k, v] of init.body.entries()) obj[k] = v;
      return obj;
    }

    return null;
  }

  function buildInjectedPayload(bodyObj) {
    const accessories = collectAccessories();
    if (!accessories.length) return null;

    if (bodyObj && Array.isArray(bodyObj.items)) {
      return { ...bodyObj, items: bodyObj.items.concat(accessories) };
    }

    const mainId = bodyObj && (bodyObj.id || bodyObj["id"]);
    const mainQty = bodyObj && (bodyObj.quantity || bodyObj["quantity"]);

    if (mainId) {
      const qty = parseInt(mainQty, 10);
      const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1;

      return {
        items: [{ id: Number(mainId), quantity: safeQty }].concat(accessories)
      };
    }

    return null;
  }

  window.fetch = async function (input, init) {
    if (!hasAccessoriesUI() || pmInjectGuard) return originalFetch(input, init);
    if (!isCartAddRequest(input)) return originalFetch(input, init);

    try {
      const bodyObj = await parseBodyToObject(init);
      const injected = buildInjectedPayload(bodyObj);

      // No accessories selected -> let theme behave normally
      if (!injected) return originalFetch(input, init);

      pmInjectGuard = true;

      const newInit = {
        ...(init || {}),
        method: "POST",
        headers: {
          ...(init && init.headers ? init.headers : {}),
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(injected)
      };

      const res = await originalFetch(input, newInit);

      // IMPORTANT: theme has no drawer -> force refresh so cart UI updates
      if (!pmReloadGuard && res && res.ok) {
        pmReloadGuard = true;
        setTimeout(() => {
          try { window.location.reload(); } catch (e) {}
        }, 150);
      }

      pmInjectGuard = false;
      return res;
    } catch (e) {
      pmInjectGuard = false;
      return originalFetch(input, init);
    }
  };

  function init() {
    bindToggles();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
